import React, {
  useContext
} from "react";
import styles from "../Wyszukiwarka.module.css";
import { AppContext } from "context/AppContext";



  export default function ProcesyElementow({element_proces_id,setElement_proces_id }) {


const contextApp = useContext(AppContext);
    const procesList = contextApp.procesList;


  return (
    <div className={styles.colData}>
      <label className={styles.labelData}> Proces </label>
      <select
        className={styles.inputData}
        style={{width:"280px"}}
        value={element_proces_id}
        onChange={(event) => {
          setElement_proces_id( event.target.value);
            // 
      // setStaus(3)
           ;
        }}
      >
        <option key={1} value={"0"}> 
           wybierz...
          </option>
          {procesList.filter(x=> x.nazwa_id != 6).sort((a,c)=>a.nazwa_id-c.nazwa_id).map((option) => (
            <option key={option.id} value={option.id}>
              {option.nazwa} {option.typ}  {option.rodzaj} {option.wykonczenie} {option.obszar}
            </option>
          ))}
      </select>

    </div>
  );
}